import { cx } from '@linaria/core';
import { resets } from '@ui/css';
import { Tooltip } from '@ui/kit';
import { withSlots, Chevron } from '@utils/react';
import { Checkmark } from './atom.checkmark.js';
import { contextMenu, badgeWrapperCls, badgeImageCls, indexBadgeCls, headerWrapperCls, headerTextCls, descriptionWrapperCls, descriptionCls, checkmark, expandCls, iconWrapperCls, button, wrapper } from './harmonica.card.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const UniversalHarmonicaCard = withSlots(function UniversalHarmonicaCard(props) {
  const contextMenu$1 = props.slots.findOne("ContextMenu");
  return /*#__PURE__*/jsx("div", {
    className: resets.rootCls,
    children: /*#__PURE__*/jsxs("div", {
      className: cx(wrapper, props.className, resets.rootCls),
      "data-formatted-lists": true,
      children: [contextMenu$1?.children && /*#__PURE__*/jsx("div", {
        className: contextMenu,
        children: contextMenu$1.children
      }), /*#__PURE__*/jsx(Tooltip, {
        body: `Aktiver ${props.title?.trim() || "opgaven"}`,
        ariaType: "label",
        placement: "top",
        pointAt: "toggler",
        containerRef: props.ref,
        children: (containerRef, togglerRef) => /*#__PURE__*/jsxs("button", {
          ref: containerRef,
          onClick: props.onClick,
          className: cx(button, props.hasShared && "hasShared"),
          children: [!!props.badgeImageSrc && /*#__PURE__*/jsxs("span", {
            className: badgeWrapperCls,
            children: [/*#__PURE__*/jsx("img", {
              className: badgeImageCls,
              src: props.badgeImageSrc,
              alt: "",
              role: "presentation"
            }), !!props.indexOrLevel && /*#__PURE__*/jsx("span", {
              className: cx(indexBadgeCls, props.audience),
              children: props.indexOrLevel
            })]
          }), /*#__PURE__*/jsxs("div", {
            className: headerWrapperCls,
            children: [/*#__PURE__*/jsx("h3", {
              className: cx(headerTextCls),
              children: /*#__PURE__*/jsx("span", {
                children: props.title
              })
            }), (Array.isArray(props.description) ? props.description.length > 0 : !!props.description) && /*#__PURE__*/jsx("div", {
              className: descriptionWrapperCls,
              children: /*#__PURE__*/jsx("span", {
                className: descriptionCls,
                children: props.description
              })
            }, "description"), props.hasShared && /*#__PURE__*/jsx(Checkmark, {
              className: checkmark
            })]
          }), /*#__PURE__*/jsx("div", {
            className: expandCls,
            children: /*#__PURE__*/jsx("span", {
              ref: togglerRef,
              className: iconWrapperCls,
              children: /*#__PURE__*/jsx(Chevron, {
                vertical: true,
                size: 10,
                lineWidth: 2
              })
            })
          })]
        })
      })]
    })
  });
});

export { UniversalHarmonicaCard };
//# sourceMappingURL=harmonica.card.js.map
